import { useMemo } from 'react'; // Import useMemo
import { BookMark } from '../types';
import { ReportTestItem } from '../utils/entities';
import { ValidationErrors } from '@/app/features/reports/types/missing-data';

// The hook now only calculates and returns a memoized value.
function useReportStats(
  filteredData: ReportTestItem[],
  missingData: Map<number, ValidationErrors>
) {
  console.debug('useReportStats', { filteredData, missingData });

  // Replace useState and useEffect with a single useMemo
  const stats = useMemo(() => {
    if (!filteredData || filteredData.length === 0) {
      return {
        bookmarks: [],
        missingSegments: 0,
        missingDataCount: 0,
      };
    }

    const missingSegments = filteredData.filter(
      (item) => item.hasFastFillQA
    ).length;

    const missingDataCount = filteredData.reduce(
      (acc, item) => (missingData.has(item.assessmentTestId) ? acc + 1 : acc),
      0
    );

    const total = filteredData.length;
    const bookmarks = filteredData.reduce((acc, item, index) => {
      const relativePosition = (index / total) * 100;
      if (item.hasUnmatchedSegments) {
        acc.push({
          index,
          title: item.assessmentTestId,
          position: relativePosition,
          type: 'fastfill',
        });
      }
      if (item.hasMissingData) {
        acc.push({
          index,
          title: item.assessmentTestId,
          position: relativePosition,
          type: 'missing',
        });
      }
      return acc;
    }, [] as BookMark[]);

    return {
      bookmarks,
      missingSegments,
      missingDataCount,
    };
  }, [filteredData, missingData]); // Dependencies remain the same

  return stats;
}

export default useReportStats;